import type { FC, ReactNode } from 'react'

import { revealDelay } from '@/lib/motion'
import Blueprint, { BLUEPRINT_CORNER } from '@/components/site/blueprint'

import { JOB_STEPS } from '@/content/business'

interface JobStepsProps {
    title?: string
}

const JobSteps: FC<JobStepsProps> = ({ title = "How a job works" }): ReactNode => {
    return (
        <section aria-labelledby='job-steps' className='relative isolate overflow-hidden bg-secondary/60'>
            <Blueprint kind='plan' className={BLUEPRINT_CORNER} />

            <div className='mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8'>
                <h2 id='job-steps' className='text-3xl font-bold sm:text-4xl' data-reveal>
                    {title}
                </h2>

                <ol className='mt-10 grid gap-6 md:grid-cols-3'>
                    {JOB_STEPS.map((step, index) => (
                        <li
                            key={step.title}
                            className='relative rounded-3xl bg-white p-7 shadow-sm'
                            data-reveal
                            style={revealDelay(index * 120)}
                        >
                            <span className='flex size-14 items-center justify-center rounded-2xl bg-primary font-heading text-3xl font-bold text-white' aria-hidden='true'>
                                {index + 1}
                            </span>

                            <h3 className='mt-5 text-2xl font-bold'>
                                <span className='sr-only'>Step {index + 1}: </span>
                                {step.title}
                            </h3>

                            <p className='mt-2 text-lg'>
                                {step.text}
                            </p>
                        </li>
                    ))}
                </ol>
            </div>
        </section>
    )
}

export default JobSteps
